import { logError } from "@/lib/error-handling";
import { apiClient } from "@/services/api";
import { PrepContextDto, PrepSource } from "@/types";

/**
 * Fetches the Call Prep context for a meeting activity.
 */
export async function fetchPrepContext(
  activityId: string
): Promise<PrepContextDto> {
  try {
    return await apiClient<PrepContextDto>(
      `/api/activities/${activityId}/prep-context`,
      { method: "GET", cache: "no-store" }
    );
  } catch (error) {
    logError(error, "fetchPrepContext");
    throw error;
  }
}

/** Prep context by prep id — the read path for the ad hoc Prep view. */
export async function fetchPrepContextByPrepId(
  prepId: string
): Promise<PrepContextDto> {
  try {
    return await apiClient<PrepContextDto>(`/api/preps/${prepId}/context`, {
      method: "GET",
      cache: "no-store",
    });
  } catch (error) {
    logError(error, "fetchPrepContextByPrepId");
    throw error;
  }
}

/** Dispatches the read to the right endpoint for the prep's source. */
export function fetchPrepContextForSource(
  source: PrepSource
): Promise<PrepContextDto> {
  return source.kind === "activity"
    ? fetchPrepContext(source.activityId)
    : fetchPrepContextByPrepId(source.prepId);
}
